import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const UPDATE_EVENT = "forja:pwa-update-ready";

/**
 * Un deploy nuevo nunca debe borrar un formulario ni cortar un request en
 * vuelo. Con una versión pendiente se aplica sola en los momentos en que no
 * hay nada que perder: al cambiar de pantalla (la URL ya es la nueva, la
 * recarga la abre con el build nuevo y evita chunks viejos que ya no existen)
 * y al volver de segundo plano si nadie escribió nada. El aviso queda sólo
 * para las sesiones largas en una misma pantalla.
 */
export function PwaUpdateNotice() {
  const [visible, setVisible] = useState(
    () => document.documentElement.dataset.forjaPwaUpdate === "ready",
  );

  useEffect(() => {
    const show = () => setVisible(true);
    window.addEventListener(UPDATE_EVENT, show);
    return () => window.removeEventListener(UPDATE_EVENT, show);
  }, []);

  const { pathname } = useLocation();
  const pathInicial = useRef(pathname);
  useEffect(() => {
    if (visible && pathname !== pathInicial.current) window.location.reload();
  }, [pathname, visible]);

  useEffect(() => {
    if (!visible) return;
    const alVolver = () => {
      if (document.visibilityState === "visible" && !document.documentElement.dataset.forjaEditado) {
        window.location.reload();
      }
    };
    document.addEventListener("visibilitychange", alVolver);
    return () => document.removeEventListener("visibilitychange", alVolver);
  }, [visible]);

  if (!visible) return null;

  const dismiss = () => {
    delete document.documentElement.dataset.forjaPwaUpdate;
    setVisible(false);
  };

  return (
    <aside className="pwa-update-notice" role="status" aria-live="polite">
      <div>
        <strong>Hay una versión nueva de FORJA</strong>
        <span>Actualizá cuando termines lo que estás haciendo.</span>
      </div>
      <div className="pwa-update-notice__actions">
        <button type="button" onClick={dismiss}>Después</button>
        <button type="button" className="pwa-update-notice__reload" onClick={() => window.location.reload()}>
          Actualizar
        </button>
      </div>
    </aside>
  );
}
